import React from 'react';
import Link from 'next/link';

export default function ClosureAnnouncement() {
  return (
    <section className="mx-auto my-12 max-w-4xl rounded-2xl border border-gray-200 bg-white p-8 font-sans text-gray-800 shadow-lg">
      <p className="mb-6">Dear Valued Client,</p>

      <p className="mb-6">
        I hope this message finds you well. After many great years of serving
        the Chattanooga community, I’ve made the difficult—but entirely
        voluntary—decision to close{' '}
        <strong>Mayes Auto Detailing and Ceramic Coatings</strong> as of{' '}
        <strong>June 30, 2025</strong>. This choice reflects the downturn of the
        economy, the physical demands on my body, and my excitement to focus on
        two new ventures!
      </p>

      <p className="mb-6">
        This wasn’t a decision I took lightly. Rather than compromise on the
        quality and attention to detail that define “MAD,” stepping away now
        will allow me to pursue fresh opportunities while ensuring you always
        receive the exceptional service you deserve.
      </p>

      <h2 className="mb-4 text-xl font-semibold">What you need to know:</h2>
      <ul className="mb-8 list-inside list-disc">
        <li className="mb-2">
          <strong>Last day of service:</strong> June 30, 2025. All appointments
          beyond that date will need to be canceled.
        </li>
        <li className="mb-2">
          <strong>Final bookings:</strong> If you have a maintenance package or
          gift card you’d like to use, please schedule by{' '}
          <strong>June 15, 2025</strong>, for the month of June so we can give
          your vehicle the full MAD treatment before closing.
        </li>
        <li className="mb-2">
          <strong>Outstanding gift cards:</strong> These will be honored through
          June 30. If you can’t book in time, let us know. You can also use the
          gift cards for one of our new ventures.
        </li>
        <li>
          <strong>Referrals:</strong> Even though we’re winding down, we want
          you to keep riding in style. Reach out and we’ll happily connect you
          with a few trusted detailers in the area.
        </li>
      </ul>

      <h2 className="mb-4 text-xl font-semibold">Looking Ahead</h2>
      <p>We are starting two new chapters of this journey:</p>
      <ul className="mb-8 list-inside list-disc">
        <li className="mb-2">
          <strong>MAD Tintz:</strong> A mobile window tinting service for
          automotive, residential, and commercial clients.
        </li>
        <li>
          <strong>Code Maze:</strong> A web design company focused on helping
          small businesses build a strong online presence.{' '}
          <Link
            href="https://www.getcodemaze.com"
            className="text-blue-600 hover:underline"
          >
            www.getcodemaze.com
          </Link>
        </li>
      </ul>

      <p className="mb-6">
        I can’t thank you enough for the trust you’ve placed in Mayes Auto
        Detailing over the years. Your loyalty, feedback, and support have made
        this journey not just possible, but deeply rewarding. It has been an
        honor to serve you, and I look forward to seeing where our paths cross
        next.
      </p>

      <p className="mb-6">
        If you have any questions or need help with final bookings, please{' '}
        <strong>
          call or text us at{' '}
          <Link href="tel:4234970881" className="text-blue-600 hover:underline">
            423-497-0881
          </Link>{' '}
          through June 30
        </strong>
        ; after that date, we will only receive emails at{' '}
        <Link
          href="mailto:info@mayesautodetailing.com"
          className="text-blue-600 hover:underline"
        >
          info@mayesautodetailing.com
        </Link>
        . You can also visit our website at{' '}
        <Link
          href="https://www.getmadpro.com"
          className="text-blue-600 hover:underline"
        >
          www.getmadpro.com
        </Link>{' '}
        <span className="italic">(soon to be rebranded for MAD Tintz)</span> for
        more details.
      </p>

      <p className="mb-6">
        Thank you for being such a vital part of the Mayes Auto Detailing
        family. Here’s to new beginnings—when clean isn’t enough…{' '}
        <em>get MAD!</em>
      </p>

      <div className="border-t border-gray-200 pt-6">
        <p className="mb-1">
          <strong>Warm regards,</strong>
        </p>
        <p>
          <strong>David Mayes</strong>
          <br />
          Owner, Mayes Auto Detailing and Ceramic Coatings
          <br />
          3921 Weldon Dr, Chattanooga, TN 37412
          <br />
          <Link href="tel:4234970881" className="text-blue-600 hover:underline">
            423-497-0881
          </Link>{' '}
          |{' '}
          <Link
            href="https://www.getmadpro.com"
            className="text-blue-600 hover:underline"
          >
            www.getmadpro.com
          </Link>{' '}
          <span className="italic">(will be rebranded for MAD Tintz)</span>
        </p>
      </div>
    </section>
  );
}
